import { render } from "./fontawesome.vue?vue&type=template&id=71350370"
import script from "./fontawesome.vue?vue&type=script&lang=js"
export * from "./fontawesome.vue?vue&type=script&lang=js"

import exportComponent from "/home/krupali/vuejs/borex-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__